import styled from "styled-components";

const ImageDropZoneBody = styled.section`
  position: absolute;
  width: 50%;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  text-align: center;
  color: #A9A9A9
`;

export default ImageDropZoneBody;
